<template>
  <div id="header" style="z-index: 99999">
    <div>
    </div>
    <div id="logo" class="light-version">
        <span>
          <router-link :to="{name: 'Dashboard'}">
            <img  v-bind:src="(isSeUrl() !== true)? $apiUrl + '/logo-idexlab.png': $apiUrl + '/logos/logo-idexlab_160wSE.png' " alt="logo" style="max-height: 100%">
          </router-link>
        </span>
    </div>
    <nav role="navigation">
      <div v-if="$route.meta.showNavigation !== false" class="header-link hide-menu"><i class="fa fa-bars"></i></div>
      <div class="small-logo">
        <span>
          <router-link :to="{name: 'Dashboard'}">
            <img  v-bind:src="$apiUrl + '/logo-idexlab.png'" alt="logo" style="max-height: 100%">
          </router-link>
        </span>
      </div>

    </nav>
  </div>
</template>
<style scoped>
  #header {
    background-color: #f7f9fa !important;
  }
</style>
<script>
export default {
  name: 'TopNavigationDeco',
  methods: {
    isSeUrl () {
      let urlSE = process.env.SE_URL
      return (window.location.origin && window.location.origin.indexOf(urlSE) !== -1)
    }
  },
  mounted () {
    $('.hide-menu').click(function (event) {
      event.preventDefault()
      if ($(window).width() < 769) {
        $('body').toggleClass('show-sidebar')
      } else {
        $('body').toggleClass('hide-sidebar')
      }
    })

    $('#navigation').slimScroll({
      height: '100%',
      opacity: 0.3,
      size: 0,
      wheelStep: 10
    })
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topNavigation/TopNavigationDeco.vue